
if ( ! window.ysCartState ) {
	window.ysCartState = {
		cart: null,
		lastLegacySignature: '',
		lastSignature: '',
		commit(cart, source, options) {
			if ( ! cart || ! Array.isArray(cart.items) ) return;

			const signature = ysGetCartSignature(cart);
			const isDuplicate = signature && signature === this.lastSignature;
			const emitLegacy = ! options || options.legacy !== false;
			this.cart = cart;
			ysSyncCartDomLineKeys(cart);

			const detail = {
				cart,
				source: source || 'cart-core',
				stateCommitted: true
			};

			if ( isDuplicate ) {
				if ( emitLegacy && signature !== this.lastLegacySignature ) {
					this.lastLegacySignature = signature;
					document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
				}
				return;
			}

			this.lastSignature = signature;

			document.dispatchEvent(new CustomEvent('ys:cart:committed', { detail }));
			if ( emitLegacy ) {
				this.lastLegacySignature = signature;
				document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
			}
		}
	};
}

function ysGetCartSignature(cart) {
	if ( ! cart || ! Array.isArray(cart.items) ) return '';

	return [
		cart.token || '',
		cart.item_count || 0,
		cart.total_price || 0,
		cart.items.map(item => {
			return [
				item && item.key ? item.key : '',
				item && item.quantity ? item.quantity : 0
			].join(':');
		}).join('|')
	].join('::');
}

function ysSyncCartDomLineKeys(cart) {
	if ( ! cart || ! Array.isArray(cart.items) ) return;

	const cartForm = document.getElementById('AjaxCartForm');
	if ( ! cartForm ) return;

	const domItems = Array.from(cartForm.querySelectorAll('[data-js-cart-item]'));
	if ( domItems.length !== cart.items.length ) return;

	domItems.forEach((element, index) => {
		const item = cart.items[index];
		if ( ! item || ! item.key ) return;

		element.dataset.id = item.key;
		element.dataset.qty = String(item.quantity || 0);

		if ( item.product_id ) {
			element.dataset.productId = String(item.product_id);
		}
	});
}

function ysGetCartMutationType(input) {
	let url = '';

	if ( typeof input === 'string' ) {
		url = input;
	} else if ( input && typeof input.url === 'string' ) {
		url = input.url;
	}

	if ( ! url ) return '';

	let path = url;
	try {
		path = new URL(url, window.location.origin).pathname;
	} catch (e) {
		path = url.split('?')[0];
	}

	const match = path.match(/\/cart\/(add|change|update|clear)(\.js)?$/);
	return match ? match[1] : '';
}

function ysIsCartObject(data) {
	return Boolean(data && Array.isArray(data.items) && typeof data.item_count !== 'undefined');
}

function ysCommitExternalCartMutation(data, type) {
	if ( ! ysIsCartObject(data) || ! window.ysCartState ) return;

	window.ysCartState.commit(data, 'external-cart-' + (type || 'mutation'), {
		legacy: false
	});
}

function ysObserveCartMutationFetches() {
	if ( typeof window.fetch !== 'function' || window.fetch.ysCartMutationObserved ) return;

	const originalFetch = window.fetch;

	window.fetch = function () {
		const mutationType = ysGetCartMutationType(arguments[0]);

		return originalFetch.apply(this, arguments).then(response => {
			if ( mutationType && response && response.ok && typeof response.clone === 'function' ) {
				response.clone().json().then(data => {
					ysCommitExternalCartMutation(data, mutationType);
				}).catch(() => {});
			}

			return response;
		});
	};

	window.fetch.ysCartMutationObserved = true;
}

function ysObserveCartMutationXhr() {
	if ( ! window.XMLHttpRequest || window.XMLHttpRequest.prototype.ysCartMutationObserved ) return;

	const originalOpen = window.XMLHttpRequest.prototype.open;
	const originalSend = window.XMLHttpRequest.prototype.send;

	window.XMLHttpRequest.prototype.open = function (method, url) {
		this.ysCartMutationType = ysGetCartMutationType(url);
		return originalOpen.apply(this, arguments);
	};

	window.XMLHttpRequest.prototype.send = function () {
		if ( this.ysCartMutationType ) {
			this.addEventListener('loadend', function () {
				if ( this.status < 200 || this.status >= 300 || ! this.responseText ) return;

				try {
					ysCommitExternalCartMutation(JSON.parse(this.responseText), this.ysCartMutationType);
				} catch (e) {}
			});
		}

		return originalSend.apply(this, arguments);
	};

	window.XMLHttpRequest.prototype.ysCartMutationObserved = true;
}

ysObserveCartMutationFetches();
ysObserveCartMutationXhr();

function ysBeforeCartDomRefresh() {
	const state = {
		preservedZapietDelivery: null
	};

	if ( window.ysZapietDeliveryModalBeforeCartRefresh ) {
		try {
			const preserved = window.ysZapietDeliveryModalBeforeCartRefresh();
			if ( preserved && preserved.nodeType === 1 ) {
				state.preservedZapietDelivery = preserved;
			}
		} catch (e) {}
	}

	return state;
}

function ysReplaceAjaxCartSubtotal(html, refreshState) {
	const subtotal = document.getElementById('AjaxCartSubtotal');
	if ( ! subtotal ) return;

	const preservedZapietDelivery = refreshState && refreshState.preservedZapietDelivery;

	subtotal.innerHTML = html;

	if (
		preservedZapietDelivery &&
		preservedZapietDelivery.querySelector &&
		preservedZapietDelivery.querySelector('#storePickupApp')
	) {
		const slot = subtotal.querySelector('[data-ys-zapiet-delivery-slot]');
		const target = slot || subtotal.querySelector('.cart__details') || subtotal;
		const beforeElement = slot ? null : target.querySelector('.cart__total') || target.querySelector('.drawer-cart-bottom-shipping') || target.querySelector('.flex-buttons') || target.querySelector('.payment-icons') || null;

		if ( ! target.contains(preservedZapietDelivery) ) {
			target.insertBefore(preservedZapietDelivery, beforeElement);
		}
	}
}

function ysAfterCartDomRefresh(refreshState) {
	if ( window.ysZapietDeliveryModalAfterCartRefresh ) {
		try {
			window.ysZapietDeliveryModalAfterCartRefresh(refreshState && refreshState.preservedZapietDelivery);
		} catch (e) {}
	}

	if ( window.ysZapietDeliveryModalEnsureSlot ) {
		try {
			window.ysZapietDeliveryModalEnsureSlot();
			setTimeout(window.ysZapietDeliveryModalEnsureSlot, 150);
			setTimeout(window.ysZapietDeliveryModalEnsureSlot, 450);
		} catch (e) {}
	}
}

function ysGetCartLanguage() {
	if ( window.ysCartLocaleGuard && typeof window.ysCartLocaleGuard.currentLanguage === 'function' ) {
		const guardedLanguage = window.ysCartLocaleGuard.currentLanguage();
		if ( guardedLanguage ) return guardedLanguage;
	}

	const pathLanguage = (window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/i) || [])[1];
	if ( pathLanguage ) return pathLanguage.toLowerCase();

	return String(document.documentElement.lang || 'de').toLowerCase().split('-')[0];
}

function ysGiftFreeLabel() {
	return ysGetCartLanguage() === 'fr' ? 'GRATUIT' : 'KOSTENLOS';
}

let ysGiftPriceObserver = null;
let ysGiftPriceObserverTimer = null;

function ysIsGiftCartItem(item) {
	if ( ! item || ! item.classList ) return false;
	if ( item.classList.contains('cart-item--subscription-free-gift') ) return true;
	if ( item.dataset && item.dataset.subscriptionFreeGift === 'true' ) return true;
	if ( item.querySelector && item.querySelector('[data-ys-gift-free-label]') ) return true;

	const title = String((item.dataset && item.dataset.title) || '').trim().toLowerCase();
	return title.indexOf('geschenk:') === 0 || title.indexOf('cadeau') === 0;
}

function ysNormalizeGiftCartControls(item) {
	if ( ! item || ! item.querySelectorAll ) return;

	item.querySelectorAll('.remove').forEach(remove => {
		if ( ! remove.hidden ) remove.hidden = true;
		if ( remove.getAttribute('aria-hidden') !== 'true' ) remove.setAttribute('aria-hidden', 'true');
		if ( remove.getAttribute('tabindex') !== '-1' ) remove.setAttribute('tabindex', '-1');
		if ( remove.style.getPropertyValue('display') !== 'none' || remove.style.getPropertyPriority('display') !== 'important' ) {
			remove.style.setProperty('display', 'none', 'important');
		}
		if ( remove.style.getPropertyValue('visibility') !== 'hidden' || remove.style.getPropertyPriority('visibility') !== 'important' ) {
			remove.style.setProperty('visibility', 'hidden', 'important');
		}
		if ( remove.style.getPropertyValue('pointer-events') !== 'none' || remove.style.getPropertyPriority('pointer-events') !== 'important' ) {
			remove.style.setProperty('pointer-events', 'none', 'important');
		}
	});
}

function ysNormalizeGiftPriceElements(root) {
	if ( ! root || ! root.querySelectorAll ) return;

	const label = ysGiftFreeLabel();
	root.querySelectorAll('[data-js-cart-item]').forEach(item => {
		if ( ! ysIsGiftCartItem(item) ) return;

		ysNormalizeGiftCartControls(item);

		const price = item.querySelector('.cart-item__price');
		if ( ! price ) return;

		const strong = price.querySelector('strong');
		if ( ! strong ) return;

		if ( strong.textContent !== label ) {
			strong.textContent = label;
		}

		if ( strong.getAttribute('data-ys-gift-free-label') !== 'true' ) {
			strong.setAttribute('data-ys-gift-free-label', 'true');
		}
	});
}

function ysScheduleGiftPriceNormalization(root) {
	const target = root && root.querySelectorAll ? root : document;
	ysNormalizeGiftPriceElements(target);

	window.clearTimeout(ysGiftPriceObserverTimer);
	ysGiftPriceObserverTimer = window.setTimeout(() => {
		ysNormalizeGiftPriceElements(document);
	}, 0);
}

function ysMutationMayAffectGiftPrice(mutation) {
	const target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
	if ( target && target.closest && target.closest('[data-js-cart-item]') ) return true;

	return Array.from(mutation.addedNodes || []).some(node => {
		if ( node.nodeType !== 1 ) return false;
		return (
			(node.matches && node.matches('[data-js-cart-item], .cart-item__actions, .cart-item__price, .remove, .feather-trash-2, [data-ys-gift-free-label], [data-subscription-free-gift]')) ||
			(node.querySelector && node.querySelector('[data-js-cart-item], .cart-item__actions, .cart-item__price, .remove, .feather-trash-2, [data-ys-gift-free-label], [data-subscription-free-gift]'))
		);
	});
}

function ysStartGiftPriceObserver() {
	if ( ysGiftPriceObserver || ! document.body || typeof MutationObserver !== 'function' ) return;

	const target = document.getElementById('site-cart-sidebar') || document.body;
	ysGiftPriceObserver = new MutationObserver(mutations => {
		if ( mutations.some(ysMutationMayAffectGiftPrice) ) {
			ysScheduleGiftPriceNormalization(document);
		}
	});

	ysGiftPriceObserver.observe(target, {
		attributes: true,
		attributeFilter: ['class', 'data-subscription-free-gift', 'style', 'hidden', 'aria-hidden', 'tabindex'],
		characterData: true,
		childList: true,
		subtree: true
	});
}

function ysPrepareCartSection(sectionDocument) {
	ysNormalizeGiftPriceElements(sectionDocument);
}

function ysInitGiftPriceNormalization() {
	ysScheduleGiftPriceNormalization(document);
	ysStartGiftPriceObserver();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener('DOMContentLoaded', ysInitGiftPriceNormalization);
} else {
	ysInitGiftPriceNormalization();
}

document.addEventListener('ys:cart:locale-synced', () => {
	ysScheduleGiftPriceNormalization(document);
});

document.addEventListener('cart:updated', () => {
	ysScheduleGiftPriceNormalization(document);
});

document.addEventListener('ys:cart:committed', () => {
	ysScheduleGiftPriceNormalization(document);
});

function ysNormalizeCheckoutLanguage(value) {
	const language = String(value || '').trim().toLowerCase().replace('_', '-').split('-')[0];
	return ['de', 'fr', 'it', 'en'].indexOf(language) !== -1 ? language : '';
}

function ysCheckoutLanguage() {
	const pathLanguage = ysNormalizeCheckoutLanguage((window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/i) || [])[1]);
	if ( pathLanguage ) return pathLanguage;

	const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
	const rootLanguage = ysNormalizeCheckoutLanguage((String(shopifyRoot || '').match(/^\/([a-z]{2})(?:\/|$)/i) || [])[1]);
	if ( rootLanguage ) return rootLanguage;

	return (
		ysNormalizeCheckoutLanguage(document.documentElement.lang) ||
		ysNormalizeCheckoutLanguage(window.Shopify && window.Shopify.locale) ||
		'de'
	);
}

function ysCheckoutForm() {
	return document.getElementById('cart') || document.querySelector('#AjaxCartForm form');
}

function ysEnsureCheckoutHiddenInput(form, name, value) {
	let input = form.querySelector('input[type="hidden"][name="' + name + '"]');

	if ( ! input ) {
		input = document.createElement('input');
		input.type = 'hidden';
		input.name = name;
		form.appendChild(input);
	}

	if ( input.value !== value ) {
		input.value = value;
	}
}

function ysLocalizeCheckoutAction(form, language) {
	const rawAction = form.getAttribute('action') || '/cart';
	let localizedAction = rawAction;

	try {
		const url = new URL(rawAction, window.location.origin);
		url.searchParams.set('locale', language);
		localizedAction = url.pathname + url.search + url.hash;
	} catch (e) {
		const cleanedAction = rawAction
			.replace(/([?&])locale=[^&]*&?/i, '$1')
			.replace(/[?&]$/, '');
		const separator = cleanedAction.indexOf('?') === -1 ? '?' : '&';
		localizedAction = cleanedAction + separator + 'locale=' + encodeURIComponent(language);
	}

	if ( localizedAction !== rawAction ) {
		form.setAttribute('action', localizedAction);
	}
}

let ysCheckoutLocaleSyncTimer = null;
let ysCheckoutLocaleObservedForm = null;
let ysCheckoutLocaleFormObserver = null;

function ysScheduleCheckoutLocaleSync(delay) {
	window.clearTimeout(ysCheckoutLocaleSyncTimer);
	ysCheckoutLocaleSyncTimer = window.setTimeout(() => {
		ysSyncCheckoutLocale();
		ysObserveCheckoutLocaleForm();
	}, typeof delay === 'number' ? delay : 0);
}

function ysObserveCheckoutLocaleForm() {
	const form = ysCheckoutForm();
	if ( ! form || form === ysCheckoutLocaleObservedForm ) return;

	if ( ysCheckoutLocaleFormObserver ) {
		ysCheckoutLocaleFormObserver.disconnect();
	}

	ysCheckoutLocaleObservedForm = form;
	ysCheckoutLocaleFormObserver = new MutationObserver(() => {
		ysScheduleCheckoutLocaleSync(0);
	});
	ysCheckoutLocaleFormObserver.observe(form, {
		attributes: true,
		attributeFilter: ['action'],
		childList: true
	});
}

function ysSyncCheckoutLocale() {
	const form = ysCheckoutForm();
	if ( ! form ) return '';

	const language = ysCheckoutLanguage();
	ysLocalizeCheckoutAction(form, language);
	ysEnsureCheckoutHiddenInput(form, 'locale', language);
	ysEnsureCheckoutHiddenInput(form, 'checkout[locale]', language);

	form.dataset.ysCheckoutLocale = language;
	document.documentElement.dataset.ysCartLanguage = language;
	document.dispatchEvent(new CustomEvent('ys:cart:locale-synced', { detail: { language } }));

	return language;
}

if ( ! window.ysCartLocaleGuard ) {
	window.ysCartLocaleGuard = {
		currentLanguage: ysCheckoutLanguage,
		sync: ysSyncCheckoutLocale
	};
}

document.addEventListener('click', event => {
	if ( event.target.closest('button[name="checkout"], input[name="checkout"], button#CheckOut, input#CheckOut') ) {
		ysObserveCheckoutLocaleForm();
		ysSyncCheckoutLocale();
	}
}, true);

document.addEventListener('touchstart', event => {
	if ( event.target.closest('button[name="checkout"], input[name="checkout"], button#CheckOut, input#CheckOut') ) {
		ysObserveCheckoutLocaleForm();
		ysSyncCheckoutLocale();
	}
}, true);

document.addEventListener('submit', event => {
	if ( event.target && event.target.id === 'cart' ) {
		ysObserveCheckoutLocaleForm();
		ysSyncCheckoutLocale();
	}
}, true);

document.addEventListener('input', event => {
	if ( event.target.closest('#storePickupApp, .ys-zapiet-delivery') ) {
		ysScheduleCheckoutLocaleSync(0);
	}
}, true);

document.addEventListener('change', event => {
	if ( event.target.closest('#storePickupApp, .ys-zapiet-delivery') ) {
		ysScheduleCheckoutLocaleSync(0);
	}
}, true);

document.addEventListener('cart:updated', () => {
	ysScheduleCheckoutLocaleSync(0);
});

document.addEventListener('ys:cart:committed', () => {
	ysScheduleCheckoutLocaleSync(0);
});

if ( document.readyState === 'loading' ) {
	document.addEventListener('DOMContentLoaded', () => {
		ysObserveCheckoutLocaleForm();
		ysScheduleCheckoutLocaleSync(0);
	});
} else {
	ysObserveCheckoutLocaleForm();
	ysScheduleCheckoutLocaleSync(0);
}


if ( ! window.ysCartShippingStatus ) {
	window.ysCartShippingStatus = (() => {
		const fallbackStatus = {
			text: 'Im Checkout berechnet',
			color: '',
			free: false
		};
		let lastStatus = null;
		let updateTimer = null;

		const getStatusElement = () => document.getElementById('shipping-status');

		const readCurrentStatus = () => {
			const statusElement = getStatusElement();
			if ( ! statusElement ) {
				return lastStatus || fallbackStatus;
			}

			const status = {
				text: statusElement.textContent.trim() || fallbackStatus.text,
				color: statusElement.style.color || '',
				free: statusElement.classList.contains('ys-shipping-status-free') || statusElement.textContent.trim() === 'Kostenlos'
			};
			lastStatus = status;
			return status;
		};

		const getCalculatedStatus = () => {
			const totalElement = document.querySelector('#AjaxCartSubtotal .cart__total');
			if ( ! totalElement ) {
				return readCurrentStatus();
			}

			const cartTotal = Number(totalElement.dataset.cartTotal || 0);
			const thresholdSetting = Number(totalElement.dataset.cartFreeShippingGoal || 0);
			const threshold = thresholdSetting > 999 ? thresholdSetting : thresholdSetting * 100;

			if ( cartTotal > 0 && threshold > 0 && cartTotal >= threshold ) {
				return {
					text: 'Kostenlos',
					color: 'green',
					free: true
				};
			}

			return fallbackStatus;
		};

		const applyStatus = (status, isPending = false) => {
			const statusElement = getStatusElement();
			if ( ! statusElement || ! status ) return;

			statusElement.textContent = status.text;
			statusElement.style.color = status.color || '';
			statusElement.classList.toggle('ys-shipping-status-free', Boolean(status.free));
			statusElement.classList.toggle('ys-shipping-status-pending', Boolean(isPending));
		};

		const beforeRefresh = () => {
			lastStatus = readCurrentStatus();
			clearTimeout(updateTimer);
		};

		const afterRefresh = () => {
			if ( lastStatus ) {
				applyStatus(lastStatus, true);
			}

			clearTimeout(updateTimer);
			updateTimer = setTimeout(() => {
				const nextStatus = getCalculatedStatus();
				lastStatus = nextStatus;
				applyStatus(nextStatus, false);
			}, 450);
		};

		return {
			beforeRefresh,
			afterRefresh,
			refreshNow: () => {
				const nextStatus = getCalculatedStatus();
				lastStatus = nextStatus;
				applyStatus(nextStatus, false);
			}
		};
	})();
}

if ( ! window.ysCartRefreshQueue ) {
	window.ysCartRefreshQueue = {
		activeUpdate: false,
		desiredQuantities: {},
		holdTimer: null,
		isUpdating: false,
		pendingRefresh: false,
		reconcileTimer: null,
		getItemIdentity(item) {
			const itemKey = item && item.dataset ? item.dataset.id || '' : '';
			const variantId = itemKey.split(':')[0] || '';
			const productId = item && item.dataset ? item.dataset.productId || '' : '';
			return {
				key: variantId || productId,
				productId,
				variantId
			};
		},
		isGiftItem(item) {
			const title = item && item.dataset ? item.dataset.title || '' : '';
			return title.trim().toLowerCase().indexOf('geschenk:') === 0;
		},
		rememberQuantity(item, quantity) {
			if ( ! item || this.isGiftItem(item) ) return;

			const identity = this.getItemIdentity(item);
			if ( ! identity.key ) return;

			const parsedQuantity = parseInt(quantity, 10) || 0;
			if ( parsedQuantity <= 0 ) {
				delete this.desiredQuantities[identity.key];
				return;
			}

			const existing = this.desiredQuantities[identity.key];
			this.desiredQuantities[identity.key] = {
				expiresAt: Date.now() + 12000,
				productId: identity.productId,
				quantity: parsedQuantity,
				replayCount: existing && existing.quantity === parsedQuantity ? existing.replayCount : 0,
				variantId: identity.variantId
			};
		},
		findItem(desired) {
			return Array.from(document.querySelectorAll('#AjaxCartForm [data-js-cart-item]')).find(item => {
				const identity = this.getItemIdentity(item);
				return (
					desired.variantId && identity.variantId === desired.variantId
				) || (
					desired.productId && identity.productId === desired.productId
				);
			});
		},
		reconcileDesiredQuantities() {
			clearTimeout(this.reconcileTimer);
			this.reconcileTimer = setTimeout(() => {
				this.applyDesiredQuantities();
			}, 120);
		},
		applyDesiredQuantities() {
			if ( this.activeUpdate ) {
				this.reconcileDesiredQuantities();
				return;
			}

			const cartForm = document.getElementById('AjaxCartForm');
			if ( ! cartForm || typeof cartForm.updateCartQty !== 'function' ) return;

			const now = Date.now();
			for ( const key of Object.keys(this.desiredQuantities) ) {
				const desired = this.desiredQuantities[key];
				if ( ! desired || desired.expiresAt < now ) {
					delete this.desiredQuantities[key];
					continue;
				}

				const item = this.findItem(desired);
				if ( ! item ) continue;

				const currentQuantity = parseInt(item.querySelector('.qty')?.value, 10) || 0;
				if ( currentQuantity === desired.quantity ) continue;

				if ( desired.replayCount >= 3 ) {
					delete this.desiredQuantities[key];
					continue;
				}

				desired.replayCount += 1;
				cartForm.updateCartQty(item, desired.quantity);
				break;
			}
		},
		hold() {
			this.isUpdating = true;
			clearTimeout(this.holdTimer);
			this.holdTimer = setTimeout(() => {
				if ( this.activeUpdate ) return;
				this.isUpdating = false;
				this.runPendingRefresh();
				this.reconcileDesiredQuantities();
			}, 700);
		},
		start() {
			this.activeUpdate = true;
			this.isUpdating = true;
			clearTimeout(this.holdTimer);
		},
		finish() {
			this.activeUpdate = false;
			this.isUpdating = false;
			clearTimeout(this.holdTimer);
			this.runPendingRefresh();
			this.reconcileDesiredQuantities();
		},
		runPendingRefresh() {
			if ( ! this.pendingRefresh || this.isUpdating || typeof window.refreshCart !== 'function' ) return;
			this.pendingRefresh = false;
			setTimeout(() => {
				if ( this.isUpdating ) {
					this.pendingRefresh = true;
					return;
				}
				window.refreshCart();
			}, 80);
		}
	};
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			if ( ! item || ! item.dataset ) return;

			let alert = null;
			let updatedCart = null;
			if ( window.ysCartRefreshQueue ) {
				window.ysCartRefreshQueue.rememberQuantity(item, newQty);
				window.ysCartRefreshQueue.start();
			}
			if ( window.ysCartShippingStatus ) {
				window.ysCartShippingStatus.beforeRefresh();
			}
			const refreshState = ysBeforeCartDomRefresh();

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					} else if ( Array.isArray(response.items) ) {
						updatedCart = response;
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					ysPrepareCartSection(sectionInnerHTML);
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					ysNormalizeGiftPriceElements(cartItems);
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					ysReplaceAjaxCartSubtotal(cartSubtotalInnerHTML, refreshState);
					if ( window.ysCartShippingStatus ) {
						window.ysCartShippingStatus.afterRefresh();
					}
					ysAfterCartDomRefresh(refreshState);
					if ( window.ysCartRefreshQueue ) {
						window.ysCartRefreshQueue.reconcileDesiredQuantities();
					}
					if ( window.ysCartState && updatedCart ) {
						window.ysCartState.commit(updatedCart, 'component-cart-change');
					}
					if ( window.ysCartLocaleGuard && typeof window.ysCartLocaleGuard.sync === 'function' ) {
						window.ysCartLocaleGuard.sync();
					}
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
					if ( window.ysCartRefreshQueue ) {
						window.ysCartRefreshQueue.finish();
					}
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

    class CartProductQuantity extends HTMLElement { 
      constructor() {
        super();
         // var collHandle = this.dataset.collHandle;
           //this.steps = parseInt(document.getElementById('dataa-step').dataset.steps, 10) || 1;
		   this.steps = parseInt(this.dataset.steps, 10) || 1;
        // console.log('steps:', this.steps); 
           const stepsToUse = this.steps - 1; 
        // console.log('stepsToUse:', stepsToUse); 
        
        
        const qtyMinus = this.querySelector('.qty-minus');
        const qtyPlus = this.querySelector('.qty-plus');
        const holdCartRefresh = (event) => {
          if (!window.ysCartRefreshQueue) return;

          window.ysCartRefreshQueue.hold();

          const qtyInput = this.querySelector('.qty');
          const item = this.closest('[data-js-cart-item]');
          if (!qtyInput || !item) return;

          const currentValue = parseInt(qtyInput.value, 10) || 0;
          const direction = event.currentTarget && event.currentTarget.classList.contains('qty-minus') ? -1 : 1;
          const nextValue = Math.max(0, currentValue + (this.steps * direction));
          window.ysCartRefreshQueue.rememberQuantity(item, nextValue);
        };

        if (qtyMinus) qtyMinus.addEventListener('click', holdCartRefresh, true);
        if (qtyPlus) qtyPlus.addEventListener('click', holdCartRefresh, true);

        if( this.steps > 1 ){
        // if(collHandle){
        if (qtyMinus) qtyMinus.addEventListener('click', this.changeCartInput.bind(this, -stepsToUse));
        if (qtyPlus) qtyPlus.addEventListener('click', this.changeCartInput.bind(this, stepsToUse));
        }
        else{
         if (qtyMinus) qtyMinus.addEventListener('click', this.changeCartInput.bind(this));
         if (qtyPlus) qtyPlus.addEventListener('click', this.changeCartInput.bind(this)); 
        }
      }
    
      changeCartInput(amount) {
        setTimeout(() => {
          const qtyInput = this.querySelector('.qty');
          const cartForm = this.closest('cart-form') || document.getElementById('AjaxCartForm');
          if (!qtyInput || !cartForm || typeof cartForm.updateCartQty !== 'function') return;

          let newValue = parseInt(qtyInput.value, 10) || 0;

          if (this.steps > 1) {
            newValue = newValue + (parseInt(amount, 10) || 0);

            if (newValue < 0) {
              newValue = 0;
            }

            qtyInput.value = newValue;
          }

          cartForm.updateCartQty(this.closest('[data-js-cart-item]'), newValue);
        }, 0);
      }
    }

	/* class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	} */

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		if ( window.ysCartRefreshQueue && window.ysCartRefreshQueue.isUpdating ) {
			window.ysCartRefreshQueue.pendingRefresh = true;
			return Promise.resolve();
		}

		if ( window.ysCartShippingStatus ) {
			window.ysCartShippingStatus.beforeRefresh();
		}
		const refreshState = ysBeforeCartDomRefresh();
		
		return fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			ysPrepareCartSection(sectionInnerHTML);
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			ysNormalizeGiftPriceElements(cartItems);
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			ysReplaceAjaxCartSubtotal(cartSubtotalInnerHTML, refreshState);
			if ( window.ysCartShippingStatus ) {
				window.ysCartShippingStatus.afterRefresh();
			}
			ysAfterCartDomRefresh(refreshState);
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}
			if ( window.ysCartRefreshQueue ) {
				window.ysCartRefreshQueue.reconcileDesiredQuantities();
			}
			if ( window.ysCartLocaleGuard && typeof window.ysCartLocaleGuard.sync === 'function' ) {
				window.ysCartLocaleGuard.sync();
			}

		})

	}

}
